import type { DrugDetailResponse } from '@/entities/drug/api/drug.api';

/**
 * PATCH `/admin/drugs/{refYm}/{drugCode}` 본문.
 * 백엔드 `DrugUpdateRequest`와 동일. GET 전용 필드(effect/precaution/direction/memo)는 보내지 않는다.
 */
export interface DrugUpdateRequest {
  drugCodeMfds?: string;
  drugCodePharma?: string;
  drugName?: string;
  mainIngredientCode?: string;
  priceHira?: number;
  pricePharma?: number;
  unitQuantity?: string;
  baseUnit?: string;
  reimbursementType?: string;
  etcOtcType?: string;
  dataSourceType?: string;
  outOfStockFlag?: boolean;
  outOfStockFrom?: string;
  outOfStockTo?: string;
  administrationRouteType?: string;
  comparatorFlag?: boolean;
  registrationStatusType?: string;
  bioequivalenceFlag?: boolean;
  atcCode?: string;
  exposeFlag?: boolean;
  pharmaCompanyId?: number;
  pharmaCompanyName?: string;
}

/** 레거시 `mapToDrugUpdateRequest` — PATCH에 있는 필드만 담는다 */
export const mapToDrugUpdateRequest = (
  data: Partial<DrugDetailResponse> & { pharmaCompanyId?: number },
): DrugUpdateRequest => {
  const body: DrugUpdateRequest = {};

  const setIfDefined = (key: keyof DrugUpdateRequest, value: unknown) => {
    if (value !== undefined && value !== null && value !== '') {
      (body as Record<string, unknown>)[key] = value;
    }
  };

  const setIfBoolean = (key: keyof DrugUpdateRequest, value: unknown) => {
    if (typeof value === 'boolean') {
      (body as Record<string, unknown>)[key] = value;
    }
  };

  setIfDefined('drugCodeMfds', data.drugCodeMfds);
  setIfDefined('drugCodePharma', data.drugCodePharma);
  setIfDefined('drugName', data.drugName);
  setIfDefined('mainIngredientCode', data.mainIngredientCode);
  setIfDefined('unitQuantity', data.unitQuantity);
  setIfDefined('baseUnit', data.baseUnit);
  setIfDefined('reimbursementType', data.reimbursementType);
  setIfDefined('etcOtcType', data.etcOtcType);
  setIfDefined('dataSourceType', data.dataSourceType);
  setIfDefined('outOfStockFrom', data.outOfStockFrom);
  setIfDefined('outOfStockTo', data.outOfStockTo);
  setIfDefined('administrationRouteType', data.administrationRouteType);
  setIfDefined('registrationStatusType', data.registrationStatusType);
  setIfDefined('atcCode', data.atcCode);
  setIfDefined('pharmaCompanyName', data.pharmaCompanyName);

  setIfBoolean('outOfStockFlag', data.outOfStockFlag);
  setIfBoolean('comparatorFlag', data.comparatorFlag);
  setIfBoolean('bioequivalenceFlag', data.bioequivalenceFlag);
  setIfBoolean('exposeFlag', data.exposeFlag);

  if (data.priceHira != null) body.priceHira = Number(data.priceHira);
  if (data.pricePharma != null) body.pricePharma = Number(data.pricePharma);
  if (data.pharmaCompanyId != null && data.pharmaCompanyId !== 0) {
    body.pharmaCompanyId = Number(data.pharmaCompanyId);
  }

  return body;
};
